import callCmAPI from 'services/helpers/call-cm-api'
import { WebApi2Response } from 'types'
import {
  NordicCompanyUsage,
  NordicLookupsUsagePagination,
} from './get-nordic-lookups-usage'
import { toQueryString } from './nordic-lookups-query'

/******************
 * Types          *
 ******************/

export type NordicLookupSource = 'live' | 'monitoring' | 'backfill'

// One company counted for a customer in its current contract year.
export interface NordicLookupWindow {
  country: string
  local_id: string
  first_lookup_at: string | null
  last_lookup_at: string | null
  lookup_count: number
  first_route: string | null
  source: NordicLookupSource
}

export interface NordicLookupWindowsResponse {
  company: NordicCompanyUsage
  lookups: NordicLookupWindow[] // newest first
  pagination: NordicLookupsUsagePagination
}

export interface NordicLookupWindowsParams {
  page?: number
  pageSize?: number // One of 10, 20, 50, 100
  q?: string // Search on local id
}

/******************
 * Fetch from API *
 ******************/

export const getNordicLookupWindows = (
  customerId: number,
  params: NordicLookupWindowsParams = {},
): Promise<WebApi2Response<NordicLookupWindowsResponse>> =>
  callCmAPI(
    `/nordic-lookups/usage/${customerId}/lookups${toQueryString({
      page: params.page,
      page_size: params.pageSize,
      q: params.q,
    })}`,
    { method: 'get' },
  )
    .then((res) => ({
      success: true as const,
      data: res.data as NordicLookupWindowsResponse,
    }))
    .catch((err) => ({ success: false as const, data: null, error: err }))
